import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Betslip from 'features/Betslip';
import Text from '../../ui/Text';
import Button from '../../ui/Button';
import Big9Card from './Big9Card';
import Big9Service from '../../utils/Big9Service';
import Big9ServiceTerminal from '../../utils/Big9ServiceTerminal';
import { connect } from 'react-redux';
import { setCouponData, setInitialCouponItems } from 'components/big9/actions';
import { HR, Divider, Overlay } from './styled';
import SportRadarWidget from '../SportRadarWidget';
import { breakpoint } from '../../constants/breakpoints';
import Big9Turnover from './Big9Turnover';
import HintIcon from './../../images/icons/hint.svg';
import backImage from './../../images/icons/arrowLeft.svg';
import ReactTooltip from 'react-tooltip';
import { detectMobile, getBig9ResultPercents } from '../../utils/UiHelper';
import RestService from '../../utils/RestService';
import { BIG9_EVENT_STATUS } from 'constants/big9Config';
import * as UiActions from 'actions/UiActions';
import { bindActionCreators } from 'redux';
import Big9PotentialEarnings from './Big9PotentialEarnings';
import { isTerminal } from '../../utils/UiHelper';
import useTweaks from '../../features/SpilKlub/state/useTweaks';
import { hideModal, showModal } from '../../actions/UiActions';
import CreateGroupButton from 'features/SpilKlub/components/CreateGroupButton';
import useBetslipState from 'features/SpilKlub/state/useBetslipState';
import { getOngoingEvent } from '../../features/SpilKlub/state/helpers';
import { formatDate } from '../../utils/UiHelper';

const defaultTextColor = '#333';
const requestByPlatform = isTerminal() ? Big9ServiceTerminal : Big9Service;

const ContentWrapper = styled.section`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 50px 15px;
    box-sizing: border-box;
    position: relative;

    .tooltip {
        opacity: 1 !important;
        max-width: 100%;
    }

    &.terminal {
        justify-content: space-between;
        padding: 30px 125px;
    }

    @media screen and ${breakpoint.S} {
        width: 100%;
        padding: ${({ spilklubBtnOffset }) =>
            spilklubBtnOffset ? '0 7px 120px' : '0 7px 70px'};

        .tooltip {
            max-width: 100% !important;
            left: 10px !important;

            &:after {
                display: none !important;
            }
        }
    }
`;

const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    margin: 0;
    position: relative;
`;

const HeaderWrapper = styled.div`
    height: auto;
    width: calc(100% + 30px);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px 16px;
    margin: 0 0 0 -15px;
    position: relative;
    background: #fdd804;
    border-radius: 5px;
    @media screen and ${breakpoint.S} {
        width: calc(100% + 28px);
        margin-left: -14px;
        border-radius: 0;
    }
`;

const TopWrapper = styled.div`
    width: 100%;
    display: block;
    padding: 0 20px;
    box-sizing: border-box;

    p {
        p {
            margin: 0;
            padding: 0;
        }
    }

    @media screen and ${breakpoint.S} {
        padding: 0 7px;
    }
`;

const SpilWrapper = styled.div`
    overflow: hidden;
    width: 475px;
    display: block;
    box-sizing: border-box;

    &.terminal {
        width: 100%;
    }

    @media screen and ${breakpoint.B} {
        width: 100%;
    }
    @media screen and ${breakpoint.S} {
        overflow: visible;
    }
`;

const SwitcherWrapper = styled.div`
    width: 100%;
    height: auto;
    display: ${({ display }) => display || 'none'};
    position: relative;
`;
const HintWrapper = styled.div`
    width: auto;
    height: auto;
    box-sizing: border-box;
    display: block;
    position: absolute;
    left: calc(50% - 50px);
    top: calc(50% - 10px);
    transform: translateY(-50%);
    z-index: 5;
    cursor: pointer;
`;
const Hint = styled.img`
    display: block;
    box-sizing: border-box;
    position: relative;
`;

const BackButtonWrapper = styled.div`
    display: ${({ display }) => display || 'none'};
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    margin: 0;
    position: relative;
    z-index: 3;

    button {
        width: auto;
    }

    &.terminal {
        position: fixed;
        left: 50px;
        top: 50px;
    }
`;

const OfferSwitcherWrapper = styled.div`
    display: ${({ display }) => display || 'none'};
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    margin: 0;
    position: relative;
    z-index: 3;

    button {
        width: auto;
    }

    &.terminal {
        position: fixed;
        left: 50px;
        top: 50px;
    }
`;

const WrapperCreateGroupButton = styled.div`
    position: fixed;
    width: 477px;
    transform: translateY(100%);
    bottom: 54px;
    z-index: ${({ isOpen }) => isOpen || 1};
    @media screen and (min-width: 1025px) and (max-width: 1365px) {
        width: ${!detectMobile() && '477px'};
    }
    @media screen and (min-width: 1366px) and (max-width: 1600px) {
        width: ${!detectMobile() && '462px'};
    }
    @media screen and (max-width: 1023px) {
        width: calc(100% - 30px);
    }
    @media screen and (max-width: 500px) {
        width: 100%;
    }
`;

const BackArrow = styled.img`
    display: inline-block;
    margin-right: 5px;
    position: relative;
`;

const defaultPayoutsData = {
    payouts: {},
    numberOfSystems: '',
    turnover: '',
    poolUpdated: 0,
};

const Big9Spil = ({
    initialCouponItems,
    setCouponData,
    setInitialCouponItems,
    couponData,
    hideHeader = false,
    hideTurnover = false,
    innerComponentMode = false,
    showModal = () => {},
    hideModal = () => {},
}) => {
    //const { offers, status } = useOffersData([]);
    const {
        showBetslip: showBetslipState,
        setEmptySellOffer,
        isResult,
    } = useBetslipState();
    const [isVisiblePercents, setIsVisiblePercents] = useState(false);
    const [isVisibleOdds, setIsVisibleOdds] = useState(false);
    const [externalId, setExternalId] = useState(0);
    const [results, setResults] = useState([]);
    const [isVisibleMobRadar, setIsVisibleMobRadar] = useState(false);
    const [isOpenDesktopSpilklub, setIsOpenDesktopSpilklub] = useState(false);
    const [earnings, setEarnings] = useState(null);
    const [title, setTitle] = useState('');
    const [isHiddenTitle, setIsHiddenTitle] = useState(true);
    const [description, setDescription] = useState('');
    const [payoutsData, setPayoutsData] = useState(defaultPayoutsData);
    const [sportRadarType, setSportRadarType] = useState('topdown');
    const timerRef = useRef(null);
    const wrapperRef = useRef();
    const [extId, setExtId] = useState('');

    const fetchResults = () => {
        requestByPlatform
            .getResults()
            .then((res) => {
                if (res.data) {
                    /* solution for updating match time every minute while
                    we don't have a socket or some special endpoint for it */
                    if (
                        (res.data[0].status === 'ONGOING' ||
                            res.data[0].items.some(
                                (item) => item.status === 'ONGOING'
                            )) &&
                        window.location.pathname === '/big9/spil'
                    ) {
                        timerRef.current = setTimeout(
                            () => fetchResults(),
                            60000
                        );
                    }

                    setResults([...res.data[0].items]);
                    setPayoutsData({
                        payouts: {
                            ...res.data[0].payouts,
                        },
                        numberOfSystems: res.data[0].numberOfSystems,
                        turnover: res.data[0].turnover,
                        poolUpdated: res.data[0]?.poolUpdated,
                    });
                    setEarnings(res.data[0]?.projections);
                    setExternalId(res.data[0].items[0].externalId);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const {
        createPoolWithCouponMode: spilklubPoolWithCouponMode,
        disablePoolWithCoupon,
    } = useTweaks();

    useEffect(() => {
        requestByPlatform.getOffers().then((res) => {
            if (res?.data) {
                const offer = res.data.filter(
                    (offer) => offer.status === 'SELL_OPEN'
                )[0];

                if (offer?.items?.length) {
                    setEmptySellOffer(false);
                    setExtId(offer.extId);
                    setInitialCouponItems(offer.items);
                    setCouponData({
                        extId: offer.extId,
                        startTime: offer.startTime,
                        id: offer.id,
                    });
                    setPayoutsData({
                        payouts: {
                            ...offer.payouts,
                        },
                        jackpotExpected: offer.jackpotExpected,
                        numberOfSystems: offer.numberOfSystems,
                        turnover: offer.turnover,
                        poolUpdated: offer?.poolUpdated,
                    });
                    setExternalId(offer.items[0].event.externalId);
                } else {
                    setEmptySellOffer(true);
                    fetchResults();
                }
            } else {
                setEmptySellOffer(true);
                fetchResults();
            }
        });

        RestService.GetBig9Title((res) => {
            if (res?.content) {
                setIsHiddenTitle(JSON.parse(res.hidden));
                setTitle(`${res.content}`);
            }
        });

        RestService.GetBig9Description((res) => {
            if (res) {
                setDescription(`${res.content}`);
            }
        });

        return () => clearTimeout(timerRef.current);
    }, []);

    useEffect(
        () => {
            const couponFromLocalStorage = JSON.parse(
                window.localStorage.getItem('BIG9_Coupon')
            );

            if (couponData?.extId !== 0 && couponData?.extId !== '') {
                if (
                    couponData?.extId !== couponFromLocalStorage?.extId &&
                    !couponData.fromLocalStorage
                ) {
                    window.localStorage.setItem(
                        'BIG9_Coupon',
                        JSON.stringify(couponData)
                    );
                    setCouponData({ ...couponData, fromLocalStorage: true });
                } else {
                    if (!couponData.fromLocalStorage) {
                        const mergedCoupon = {
                            ...couponData, // double check
                            ...couponFromLocalStorage,
                            outcomes: {
                                ...couponFromLocalStorage.outcomes,
                                ...couponData.outcomes,
                            },
                        }; // needed for canceled events
                        setCouponData({
                            ...mergedCoupon,
                            fromLocalStorage: true,
                        });
                    } else {
                        window.localStorage.setItem(
                            'BIG9_Coupon',
                            JSON.stringify(couponData)
                        );
                    }
                }
            }
        }, // todo rework if statements
        [couponData]
    );

    useEffect(
        () => {
            if (innerComponentMode) {
                isVisibleMobRadar
                    ? showModal('SPORT_RADAR_WIDGET_POPUP', { externalId })
                    : hideModal('SPORT_RADAR_WIDGET_POPUP');
            }
        },
        [isVisibleMobRadar, externalId]
    );

    const getEventsResults = (items) => {
        if (items) {
            return items.map((item, index) => {
                let oddsPercents = getBig9ResultPercents(item);

                return (
                    <Big9Card
                        key={index}
                        competition={item.competition}
                        externalId={item.externalId}
                        startTime={item.kickoff}
                        eventName={item.name}
                        number={item.nr}
                        country={item.country}
                        isResults
                        matchResult={item.score}
                        results={item.result}
                        chooseExternalId={(externalId) => {
                            setExternalId(externalId);
                            showMatchPlugin();
                        }}
                        oddsPercents={oddsPercents}
                        isVisiblePercents
                        status={item.status}
                        matchTime={
                            item.liveScore?.status === 'Pause' &&
                            item.liveScore?.time >= 45
                                ? 'HT'
                                : item.liveScore?.time
                        }
                        className={isTerminal() ? 'terminal results' : null}
                    />
                );
            });
        }
    };

    const getBetsItems = (items) => {
        if (items.length > 0) {
            return items.map((item, index) => {
                let homeOver = Number(item.dist1O);
                let homeUnder = Number(item.dist1U);
                let tieOver = Number(item.distXO);
                let tieUnder = Number(item.distXU);
                let awayOver = Number(item.dist2O);
                let awayUnder = Number(item.dist2U);
                let wildcard = Number(item.distWC);

                let oddsPercents = {
                    '1': Math.round(homeOver + homeUnder),
                    X: Math.round(tieOver + tieUnder),
                    '2': Math.round(awayOver + awayUnder),
                    U: Math.round(homeUnder + tieUnder + awayUnder),
                    O: Math.round(homeOver + tieOver + awayOver),
                    '*': Math.round(wildcard),
                };

                let homeOdds =
                    Number(item.oddsHome) > 0 ? Number(item.oddsHome) / 100 : 0;
                let tieOdds =
                    Number(item.oddsTie) > 0 ? Number(item.oddsTie) / 100 : 0;
                let awayOdds =
                    Number(item.oddsAway) > 0 ? Number(item.oddsAway) / 100 : 0;
                let overOdds =
                    Number(item.oddOver) > 0 ? Number(item.oddOver) / 100 : 0;
                let underOdds =
                    Number(item.oddUnder) > 0 ? Number(item.oddUnder) / 100 : 0;

                let oddsAmount = {
                    '1': homeOdds,
                    X: tieOdds,
                    '2': awayOdds,
                    O: overOdds,
                    U: underOdds,
                    '*': '',
                };

                return (
                    <Big9Card
                        key={index}
                        externalId={item.event.externalId}
                        startTime={item.event.kickoff}
                        competition={item.event.competition}
                        eventName={item.name}
                        country={item.event.country}
                        number={item.nr}
                        showPercents={showPercents}
                        isVisiblePercents={isVisiblePercents}
                        isVisibleOdds={isVisibleOdds}
                        oddsPercents={oddsPercents}
                        oddsAmount={oddsAmount}
                        chooseExternalId={(externalId) => {
                            setExternalId(externalId);
                            showMatchPlugin();
                        }}
                        status={item.status}
                        className={isTerminal() ? 'terminal' : null}
                    />
                );
            });
        }
    };

    const showMatchPlugin = () => {
        if (window.innerWidth < 1366 || isTerminal()) {
            setIsVisibleMobRadar(true);
            if (isTerminal()) {
                document.getElementsByClassName('app')[0].style =
                    'overflow: hidden';
            } else {
                setSportRadarType('single');
                document.getElementsByClassName('desktop')[0].style =
                    'overflow: hidden';
            }
        }
    };

    const hideMatchPlugin = () => {
        setIsVisibleMobRadar(false);
        if (isTerminal()) {
            document.getElementsByClassName('app')[0].style = 'overflow: auto';
        } else {
            document.getElementsByClassName('desktop')[0].style =
                'overflow: auto';
        }
    };

    const showPercents = () => {
        setIsVisiblePercents(!isVisiblePercents);
    };

    const showOdds = () => {
        setIsVisibleOdds(!isVisibleOdds);
    };

    const showBetslip = () => {
        if (spilklubPoolWithCouponMode) {
            showBetslipState(true);
            return true;
        }

        const leftSide = ['1', 'X', '2'];
        const rightSide = ['O', 'U'];
        const compareBet = (arr1, arr2) => arr1.some((el) => arr2.includes(el));
        const state = Object.keys(couponData.outcomes).some((key) => {
            return (
                (couponData.outcomes[key]?.status !==
                    BIG9_EVENT_STATUS.canceled &&
                    compareBet(couponData.outcomes[key].marks, leftSide) &&
                    compareBet(couponData.outcomes[key].marks, rightSide)) ||
                couponData.outcomes[key].marks.includes('*')
            );
        });
        showBetslipState(state);
        return state;
    };

    return (
        <ContentWrapper
            className={isTerminal() ? 'terminal' : null}
            spilklubBtnOffset={
                !innerComponentMode &&
                !isResult &&
                detectMobile() &&
                showBetslip()
            }
        >
            <Divider
                className={isTerminal() ? 'terminal bets' : null}
                ref={wrapperRef}
            >
                <SpilWrapper className={isTerminal() ? 'terminal' : null}>
                    <OfferSwitcherWrapper>
                        <Button />
                    </OfferSwitcherWrapper>
                    <TopWrapper>
                        {!hideHeader && (
                            <>
                                {!isHiddenTitle ? (
                                    <HeaderWrapper>
                                        <Text
                                            size={isTerminal() ? '26' : '20'}
                                            color={defaultTextColor}
                                            margin="0"
                                            padding="0"
                                            bold
                                            align="center"
                                            uppercase
                                            dangerouslySetInnerHTML={{
                                                __html: title,
                                            }}
                                        />
                                    </HeaderWrapper>
                                ) : null}

                                <Text
                                    size={isTerminal() ? '16' : '14'}
                                    margin={
                                        isHiddenTitle && !detectMobile()
                                            ? '0'
                                            : detectMobile()
                                                ? '15px 0 0'
                                                : '8px 0 0'
                                    }
                                    padding={isHiddenTitle ? '0' : 'auto'}
                                    color={defaultTextColor}
                                    align="left"
                                    dangerouslySetInnerHTML={{
                                        __html: description,
                                    }}
                                />
                                {couponData?.startTime ? (
                                    <Text
                                        size={isTerminal() ? '16' : '14'}
                                        margin="0"
                                        padding={'0'}
                                        color={defaultTextColor}
                                        align="left"
                                        bold
                                    >
                                        Spilstop{' '}
                                        {formatDate(
                                            couponData?.startTime,
                                            'dddd [kl.] HH:mm'
                                        )}
                                    </Text>
                                ) : null}
                            </>
                        )}
                        <HR margin={'15px 0 0'} />
                        <SwitcherWrapper display={isResult ? 'none' : 'block'}>
                            <HintWrapper>
                                <Hint
                                    src={HintIcon}
                                    data-for={'tooltip_big9'}
                                    data-tip="Her kan du se, hvordan de øvrige spillere tror,<br> at kampen slutter (vist i procent af alle spillede kuponer)"
                                    data-multiline={true}
                                    data-effect={'solid'}
                                    data-event={
                                        isTerminal() || detectMobile()
                                            ? 'click'
                                            : ''
                                    }
                                />
                            </HintWrapper>

                            <ButtonsWrapper>
                                <Button
                                    onClick={showPercents}
                                    margin="0"
                                    width="calc(50% - 7px)"
                                    lightBlue
                                    active={isVisiblePercents}
                                    position={'relative'}
                                    fontSize={isTerminal() ? '16px' : '14px'}
                                    className={
                                        isTerminal()
                                            ? 'terminalSwitcher'
                                            : 'webSwitcher'
                                    }
                                >
                                    <span className="disc" />
                                    Vis tendens
                                </Button>
                                <Button
                                    margin="0"
                                    width="calc(50% - 7px)"
                                    lightBlue
                                    onClick={showOdds}
                                    active={isVisibleOdds}
                                    fontSize={isTerminal() ? '16px' : '14px'}
                                    className={
                                        isTerminal()
                                            ? 'terminalSwitcher'
                                            : 'webSwitcher'
                                    }
                                >
                                    <span className="disc" />
                                    Vis odds
                                </Button>
                            </ButtonsWrapper>
                        </SwitcherWrapper>

                        <HR />

                        {earnings !== null &&
                        Object.keys(earnings).length > 0 ? (
                            <Big9PotentialEarnings
                                earnings={earnings}
                                isResultPage
                                ongoingEvent={getOngoingEvent(results)}
                            />
                        ) : null}
                    </TopWrapper>

                    {isResult
                        ? getEventsResults(results)
                        : getBetsItems(initialCouponItems)}
                    {!isTerminal()
                        ? showBetslip() && (
                              <Betslip
                                  innerComponentMode={innerComponentMode}
                                  spilklubPoolWithCouponMode={
                                      spilklubPoolWithCouponMode
                                  }
                                  disablePoolWithCoupon={disablePoolWithCoupon}
                                  shareFullOpenState={() => {
                                      setIsOpenDesktopSpilklub(false);
                                  }}
                              />
                          )
                        : null}

                    {!innerComponentMode &&
                        !detectMobile() && (
                            <WrapperCreateGroupButton
                                isOpen={
                                    isOpenDesktopSpilklub &&
                                    !spilklubPoolWithCouponMode
                                        ? 10
                                        : 1
                                }
                            >
                                <CreateGroupButton
                                    parentRef={wrapperRef?.current}
                                    changeDesktopIndex={() =>
                                        setIsOpenDesktopSpilklub(
                                            !isOpenDesktopSpilklub
                                        )
                                    }
                                />
                            </WrapperCreateGroupButton>
                        )}

                    {!hideTurnover && Object.keys(payoutsData).length > 0 ? (
                        <Big9Turnover
                            isResultPage={isResult}
                            payoutsData={payoutsData}
                        />
                    ) : null}
                </SpilWrapper>
            </Divider>
            {!innerComponentMode && (
                <Divider
                    padding="0 0 0 35px"
                    className={
                        isTerminal()
                            ? 'terminal sportRadarWrapper'
                            : 'sportRadarWrapper'
                    }
                    display={isVisibleMobRadar ? 'flex' : 'none'}
                >
                    {!isTerminal() ? (
                        <BackButtonWrapper
                            display={
                                (isVisibleMobRadar &&
                                    window.innerWidth <= 1366) ||
                                isTerminal()
                                    ? 'flex'
                                    : 'none'
                            }
                        >
                            <Button
                                margin="0"
                                padding="10px 15px"
                                fontSize="12px"
                                onClick={() => {
                                    hideMatchPlugin();
                                }}
                                lynch
                            >
                                <BackArrow src={backImage} />
                                <span>Tilbage</span>
                            </Button>
                        </BackButtonWrapper>
                    ) : null}

                    <SportRadarWidget
                        externalId={externalId}
                        isLive={false}
                        layout={sportRadarType}
                    />
                    {isTerminal() ? (
                        <Overlay
                            onClick={() => {
                                hideMatchPlugin();
                            }}
                        />
                    ) : null}
                </Divider>
            )}
            {isTerminal() ? (
                <Divider className={'terminal betSlip'}>
                    <Betslip isTerminal={isTerminal()} />
                </Divider>
            ) : null}

            <ReactTooltip
                border={false}
                id={'tooltip_big9'}
                showTabSwitcher={false}
                container="srf-widget"
                className="tooltip big9"
                type="dark"
                place="top"
                backgroundColor="#333333"
                globalEventOff="click"
            />
        </ContentWrapper>
    );
};

const mapStateToProps = (state) => {
    return {
        couponData: state.big9.couponData,
        initialCouponItems: state.big9.initialCouponItems,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCouponData: (couponData) => {
            dispatch(setCouponData(couponData));
        },
        setInitialCouponItems: (items) => {
            dispatch(setInitialCouponItems(items));
        },
        uiActions: bindActionCreators(UiActions, dispatch),
        showModal: (modalId, data) => dispatch(showModal(modalId, data)),
        hideModal: (modalId) => dispatch(hideModal(modalId)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Big9Spil);
